import { Tag, TagGroup, TagList, Tooltip, TooltipTrigger } from '@launchpad-ui/components';
import clsx from 'clsx';

import { EnvironmentMarker } from '../EnvironmentMarker';
import { MarketplaceEnvironmentIndicator } from '../MarketplaceEnvironmentIndicator/MarketplaceEnvironmentIndicator';

import styles from './EnvironmentMarkerWithName.module.css';

export type EnvironmentMarkerWithNameEnvironment = {
  key: string;
  name: string;
  color: string;
  critical?: boolean;
};

export type EnvironmentMarkerWithNameProps = {
  env: EnvironmentMarkerWithNameEnvironment;
  href?: string;
  className?: string;
  environmentMarkerClassName?: string;
  environmentNameClassName?: string;
  omitName?: boolean;
  openInNewTab?: boolean;
  showCriticalEnvironmentMarker?: boolean;
  onClickEnvironmentLink?(): void;
};

export function EnvironmentMarkerWithName({
  env,
  className,
  environmentMarkerClassName,
  environmentNameClassName,
  href,
  omitName = false,
  openInNewTab = false,
  showCriticalEnvironmentMarker = false,
  onClickEnvironmentLink,
}: EnvironmentMarkerWithNameProps) {
  const environmentNameElement = <span className={environmentNameClassName}>{env.name}</span>;

  const renderEnvironmentName = () => {
    if (omitName) {
      return null;
    }

    if (href) {
      return (
        <a
          className={styles.link}
          href={href}
          onClick={onClickEnvironmentLink}
          {...(openInNewTab ? { target: '_blank', rel: 'noreferrer' } : {})}
        >
          {environmentNameElement}
        </a>
      );
    }

    return environmentNameElement;
  };

  return (
    <>
      <span className={clsx(styles.nowrap, className)}>
        <EnvironmentMarker color={env.color} className={clsx(styles.marker, environmentMarkerClassName)} />
      </span>
      {renderEnvironmentName()}
      <MarketplaceEnvironmentIndicator envKey={env.key} />
      {showCriticalEnvironmentMarker && env.critical && (
        <TagGroup className={styles.criticalTag} aria-label="type">
          <TagList>
            <Tag size="small">
              <TooltipTrigger>
                Critical
                <Tooltip>
                  Critical environments affect your customers or the health of your systems and may have added
                  safeguards in place.
                </Tooltip>
              </TooltipTrigger>
            </Tag>
          </TagList>
        </TagGroup>
      )}
    </>
  );
}
